import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import axios from 'axios'
import Swal from 'sweetalert2'

const EditCourseModal = ({ course_id, show, handleClose }) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [price, setPrice] = useState(0)

  const token = localStorage.getItem('jwttoken')
  const url = 'https://kaasbackend.vetrinahealthcare.com/'

  useEffect(() => {
    // Fetch course details when the modal is opened
    if (show) {
      axios
        .get(`${url}lms/courses/${course_id}/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const { title, description, price } = response.data
          setTitle(title || '') // Populate the title
          setDescription(description || '') // Populate the description
          setPrice(price || 0) // Populate the price
        })
        .catch((error) => {
          console.error('Error fetching course details:', error)
        })
    }
  }, [show, course_id, url, token])

  const handleTitleChange = (e) => {
    setTitle(e.target.value)
  }

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value)
  }

  const handlePriceChange = (e) => {
    setPrice(e.target.value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const reqData = {}
    if (title) reqData['title'] = title
    if (description) reqData['description'] = description
    if (price) reqData['price'] = price

    axios
      .patch(`${url}lms/courses/${course_id}/`, reqData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        Swal.fire({
          title: 'Course Updated',
          text: 'Course details have been updated successfully',
          icon: 'success',
          timer: 1000,
        })
        handleClose() // Close the modal after a successful update
      })
      .catch((error) => {
        console.error('Error updating course:', error)
        Swal.fire({
          title: 'Error',
          text: 'Failed to update course details',
          icon: 'error',
        })
      })
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Course</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId='title'>
            <Form.Label>Title</Form.Label>
            <Form.Control
              type='text'
              value={title}
              onChange={handleTitleChange}
            />
          </Form.Group>
          <Form.Group controlId='description' className='mt-3'>
            <Form.Label>Description</Form.Label>
            <Form.Control
              type='text'
              value={description}
              onChange={handleDescriptionChange}
            />
          </Form.Group>

          <Form.Group controlId='price' className='mt-3'>
            <Form.Label>Price</Form.Label>
            <Form.Control
              type='number'
              value={price}
              onChange={handlePriceChange}
            />
          </Form.Group>
          <Button className='mt-3' variant='primary' type='submit'>
            Update Course
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default EditCourseModal
